import { getKey } from "@piqnt/runtime-core/common/Key";
import { type PlainBody, type PlainFixture, type PlainJoint, type PlainWorld } from ".";

interface WithKey {
  __key: string;
}

export function findPlainBody(world: PlainWorld, key: string | WithKey): PlainBody | undefined {
  if (!world) return undefined;
  if (typeof key === "object") key = getKey(key);
  if (!key) return undefined;
  for (const body of world.bodies) {
    if (getKey(body) === key) return body;
  }
}

export function findPlainFixture(world: PlainWorld, key: string | WithKey): PlainFixture | undefined {
  if (!world) return undefined;
  if (typeof key === "object") key = getKey(key);
  if (!key) return undefined;
  for (const body of world.bodies) {
    for (const fix of body.fixtures) {
      if (getKey(fix) === key) return fix;
    }
  }
}

export function findPlainJoint(world: PlainWorld, key: string | WithKey): PlainJoint | undefined {
  if (!world) return undefined;
  if (typeof key === "object") key = getKey(key);
  if (!key) return undefined;
  for (const joint of world.joints) {
    if (getKey(joint) === key) return joint;
  }
}

export * from "@piqnt/runtime-core/common/Key";
